import { Component, Input, OnInit } from '@angular/core';
import { Employee } from 'src/app/shared/models/employee/employee';
import { Funder } from 'src/app/shared/models/funder';
import {
	FunderReportDaily,
	FunderReportWeekly
} from 'src/app/shared/models/funder-report-weekly';
import { DateUtils } from 'src/app/shared/utils/date-utils';
import { WorkBook, WorkSheet, writeFile, utils } from 'xlsx';

@Component({
	selector: 'app-funder-report',
	templateUrl: './funder-report.component.html',
	styleUrls: ['./funder-report.component.scss']
})
export class FunderReportComponent {
	@Input() funderReport: FunderReportWeekly;
	@Input() funders: Funder[];

	constructor(private dateUtils: DateUtils) {}

	exportExcel(employee?: Employee) {
		const wb: WorkBook = utils.book_new();

		if (employee) {
			const element = document.getElementById(
				'funderReportTable' + employee.id
			);
			const ws: WorkSheet = utils.table_to_sheet(element);
			const sheetName = employee.firstName + '_' + employee.lastName;
			utils.book_append_sheet(wb, ws, sheetName);
		} else {
			this.funderReport.employeesReport.forEach((empReport) => {
				const emp = empReport.employee;
				const element = document.getElementById('funderReportTable' + emp.id);
				const ws: WorkSheet = utils.table_to_sheet(element);
				const sheetName = emp.firstName + '_' + emp.lastName;
				utils.book_append_sheet(wb, ws, sheetName);
			});
		}

		const fileName =
			'RapportFinanceur_' +
			this.funderReport.year +
			'_' +
			this.funderReport.weekNumber +
			'.xlsx';

		writeFile(wb, fileName);
	}

	getDate(date: string | Date) {
		return new Date(date).toLocaleDateString('fr-Fr');
	}

	timeConvert(min: number) {
		if (min === 0) {
			return min;
		}
		return this.dateUtils.timeConvert(min);
	}

	getCorrespondingFunderReport(dayReport: FunderReportDaily, funderId: number) {
		return dayReport.funderReports.find(
			(funderReport) => funderReport.funder.id === funderId
		);
	}
}
